/*
 * Ask Question Module
 *
 * Description:
 * This module is meant for asking question and all the actions associated with it(e.g. form open on focus, form 
 * submission on click etc)
 *
 * Purpose:
 * This module is necessary since ask question is needed on multiple pages and 
 * this module can be inserted wherever needed and appropriate events are binded
 * 
 * Inputs
 * onPostQuestionCallback: Function to be executed on posting a question
 * 
 * Outputs
 * Returns a function that is the instance of the module
 * 
 * @authors: Chiran Doshi and Elton Jain
 */

define('FeedAskQuestion',['jquery', 'UI', 'Validation','History', 'Config'], function($, UI, Validation, History, Config) {
    'use strict';

    // Ask Question Form Validation rules
    var langs = Config.get('lang'),
        askQValidationRules = {
        step1: {
            message: {
                presence: {
                    message: '^' + langs.err_q_blank
                },
                length: {
                    minimum: 10,
                    tooShort: '^' + langs.err_q_len
                }
            }
        }
    };

    return function(options) {

        var o,
            defaults = {
                onPostQuestionCallback: null,
                previewQuestion: 'question-preview'
            },
            $txtPostQuestion,
            $formPostQuestion,
            $previewQuestion,
            $elePostQuestionAttachment,
            objImageForm = {},
            groupRendered = false,
            previewURL = '',
            link_data,
            preview_type,

            /**
             * [_switchQStep determines the portion of form to be displayed]
             *
             * @param  Integet step [portion of the form to be displayed]
             *
             */
            _switchQStep = function(step) {
                var step = (step - 1) || 0,
                    steps = ['write', 'choose'];

                if (step < 0 || step > 1) {
                    step = 0;
                }

                $formPostQuestion.find('.q-attach-count').addClass('hidden');
                $formPostQuestion.children('.step-' + steps[step]).removeClass('hidden').siblings('.q-step').addClass('hidden');
            },

            /**
             * [_resetQuestionForm resets the form on close or after posting a question]
             *
             */
            _resetQuestionForm = function() {
                $elePostQuestionAttachment.addClass('hidden').children('ul').html('');
                $formPostQuestion[0].reset();
                $formPostQuestion.removeClass('open');
                
                $formPostQuestion.find('.ask-q-bucket').addClass('noquery');
                _switchQStep(1);
            },

            /**
             * [_closeQuestionForm function is invoked on closing the form]
             *
             * @param  Function callback [function that is executed]
             *
             */
            _closeQuestionForm = function(callback) {
                _resetQuestionForm();
                $formPostQuestion.removeClass('open loading');
                $elePostQuestionAttachment.html('');
                UI.noscroll(false);
                UI.showBackButton(false);
                if (callback) {
                    callback();
                }
            },

            _checkForLinkPreview = function() {
                var imageCount = parseInt($formPostQuestion.find('.count').html());
                
                if(imageCount > 0) {
                    return;
                }
                require(['linkify'], function(linkify) {
                    var link = linkify.find($('#txtPostQuestion').val());
                    if(link.length > 0 && link[0].type == 'url') {
                        if(link[0].value != previewURL) {
                            $previewQuestion.addClass('loading');
                            $.post('/ajax/parse/question',{q: link[0].value}, function(response) {
                                $('.question-preview').removeClass('loading');
                                if(response.status && response.response && response.response.link_data && response.response.link_data.thumbnail) {
                                    $('.question-preview .preview-img').css('background-image','url("' +  response.response.link_data.thumbnail + '")');
                                    var title = response.response.link_data.title,
                                        description = response.response.link_data.description,
                                        device = Config.get('device');

                                    if(device === 'desktop') {

                                        if(title.length > 100) {
                                            title = title.substring(0,100) + '...';
                                        }

                                        if(description.length > 100) {
                                            description = description.substring(0,140) + '...';
                                        }

                                    } else {
                                        if(title.length > 75) {
                                            title = title.substring(0,75) + '...';
                                        }

                                        if(description.length > 75) {
                                            description = description.substring(0,75) + '...';
                                        }
                                    }
                                    

                                    $('.question-preview .title').html(title);
                                    $('.question-preview .description').html(description);

                                    $previewQuestion.addClass('available');
                                    link_data=response.response.link_data;
                                    preview_type = response.response.type;
                                } else {
                                    $previewQuestion.removeClass('available');
                                }
                            });
                            previewURL = link[0].value;    
                        }
                    } else {
                        $previewQuestion.removeClass('available');
                    }
                });
            },

           

            /**
             * [_bindEvents binds the appropriate events to the ask question form]
             *
             */
            _bindEvents = function() {
                // Open the form on click or focus
                $formPostQuestion.on('click', function(e) {
                // $txtPostQuestion.on('focus click', function(e) {
                    // var $input = $(this);
                    openQuestionForm.call(this, e);
                });

                // Show Ask question options and disable searching
                $formPostQuestion.on('click', '#btnPostAskMode', function () {
                    $formPostQuestion.removeClass('search-mode');
                    History.pushState({
                        callback: function () {
                            $formPostQuestion.addClass('search-mode');
                        }
                    });

                    _checkForLinkPreview();

                });

                // Close and reset the form
                $formPostQuestion.on('click', '.q-step .btn-back', function() {
                    History.popState();
                    
                    return false;
                });

                /**
                 * Quick search questions
                 */
                require(['Helper', 'JSTemplate'], function (Helper, template) {
                    var api = '/ajax/similarquestions',
                        $elQSearchList = $('#qBucketList'),
                        $elQSearchListWrap = $elQSearchList.closest('.ask-q-bucket'),
                        $elSearchOption = $('#lblAskSearchOption'),
                        query = null;

                    $txtPostQuestion.on('keyup', Helper.debounce(function() {
                        if(!$formPostQuestion.is('.search-mode')) {
                            _checkForLinkPreview();
                            return false;
                        }
                        query = $.trim($txtPostQuestion.val());
                        if(!query) {
                            $elQSearchListWrap.addClass('noquery');
                            return false;
                        }
                        $elSearchOption.text(query);
                        $.post(api, {
                            q: query,
                            type: 'topic'
                        }, function(response) {
                            if(response.status == true && response.response.length > 0) {
                                var html =  template('tplQuestionList', {data: response.response});
                                $elQSearchList.html(Helper.highlight(html, query));
                            }
                            arrangeStuff(response.response);
                        });
                    }, 500));

                    function arrangeStuff(data) {
                        // If nothing
                        // If no data
                        // If data
                        if(data === false) {
                            $elQSearchListWrap.addClass('hidden');
                            return false;
                        }
                        $elQSearchListWrap.removeClass('hidden');
                        $elQSearchListWrap.removeClass('noquery');
                        if(!data || !data.length) {
                            $elQSearchListWrap.addClass('empty');
                        } else {
                            $elQSearchListWrap.removeClass('empty');
                        }
                    }
                    $elSearchOption.on('click', function () {
                        History.clearStates(1, function () {
                            $formPostQuestion[0].reset();
                            window.location.href = '/search?q='+query;
                        });
                        return false;
                    });

                    // On click close preview
                    UI.$b.on('click', '.close-preview', function() {
                        var base = $(this);
                        base.closest('.question-preview').removeClass('available');
                    });

                    // On clicking a search item
                    $elQSearchList.on('click', '>li', function () {
                        var $this = $(this),
                            qId = $this.data('id');
                        $this.addClass('loading');
                        
                        require(['FeedQuestions', 'Mixpanel'], function (FeedQuestions, MixPanel) {
                            FeedQuestions.showQuestionPage(qId, {
                                callback: function () {
                                    var mixpanelData = {
                                        target: 'asksearch item',
                                        content_id: qId,
                                        content_type: 'question'
                                    };
                                    MixPanel.hit('click', mixpanelData);
                                    $this.removeClass('loading');
                                }
                            });
                        });
                    });
                });

                $formPostQuestion.on('submit', function() {

                    var $form = $formPostQuestion,
                        images = objImageForm ? objImageForm.getImages() : null,
                        formData = $.extend($form.serializeArray(), {}),
                        _fd = new FormData();

                    $.each(images, function(i, file) {
                        _fd.append('image' + i, file);
                    });

                    $.each(formData, function(i, input) {
                        _fd.append(input.name, input.value);
                    });

                    // For the preview
                    if($('.question-preview.available').length > 0) {
                        _fd.append('type', preview_type);
                        _fd.append('link_data', JSON.stringify(link_data));
                    }

                    _fd.append('groupId',0);


                    var validation = new Validation({
                        form: $(this),
                        allConstraints: $.extend({}, askQValidationRules.step1)
                    });


                    if (validation.isValid() !== true) {
                        return;
                    }

                    $form.addClass('loading');

                    $.ajax({
                        url: '/ajax/question/save',
                        data: _fd,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(response) {
                            $form.removeClass('loading');
                            if (response.status === true) {
                                // Close form
                                var mixpanelData = {
                                    'question_id': response.response[0].topic.id,
                                    'question_text': response.response[0].topic.message,
                                    'user': response.response[0].topic.user.fullname,
                                    'user_id': response.response[0].topic.user.id
                                };
                                require(['Mixpanel'], function(MixPanel) {
                                    MixPanel.hit('question_create', mixpanelData);
                                    window.location = response.response[0].topic.url;
                                });

                                return false;

                                History.popState(function() {
                                    _closeQuestionForm(function() {
                                        objImageForm.reset();
                                    });
                                }); // Step 1

                                if(Config.get('page.route') === 'home' || (Config.get('page.route') === 'group' && !window._gtap.data.pageGroupData.ama_info)) {
                                    History.popState(); // Step 2
                                }
                                
                                _fd = null;
                                
                                if (o.onPostQuestionCallback) {
                                    o.onPostQuestionCallback(response, $formPostQuestion);
                                }
                            } else if(response && response.message) {
                                require(['Toastr'], function(Toastr) {
                                    new Toastr({
                                        'message': response.message
                                    });
                                });
                                return false;
                            }
                        }
                    });

                    return false;
                });

                // Add noscroll if "opening question form auto"
                if($formPostQuestion.is('.open')){
                    UI.noscroll();
                }
            },
            openQuestionForm = function (e) {
                if(!$formPostQuestion.is('.open')) {
                    if(e) {
                        e.preventDefault();
                        if(e.target === $txtPostQuestion[0]) {
                            $txtPostQuestion.blur();
                        }
                    }
                    UI.noscroll();
                    $formPostQuestion.addClass('open');
                    UI.showBackButton();
                    History.pushState({
                        popupId: o.formPostQuestion,
                        removeEl: false,
                        isPage: true,
                        callback: function(items) {
                            if(items && items.length > 0 && items[items.length - 1].isPage === true) {
                                UI.showBackButton(true);
                            } else {
                                UI.showBackButton(false);
                            }
                            _closeQuestionForm(function() {
                                objImageForm.reset();
                            });
                        }
                    });
                    return false;
                }
            },
            init = function(options) {
                o = $.extend(defaults, options);

                if (!o.formPostQuestion || !o.txtPostQuestion || !o.postAttachments || !o.postFileSelect || !o.btnPostAttach) {
                    throw ('Ask Question: Pass arguments correctly');
                }

                $formPostQuestion = $('#' + o.formPostQuestion);
                $txtPostQuestion = $('#' + o.txtPostQuestion);
                $elePostQuestionAttachment = $('#' + o.postAttachments),
                $previewQuestion = $('.' + o.previewQuestion);

                var $elFormImageCount = $formPostQuestion.find('.q-attach-count');
                require(['ImageForm'], function (ImageForm) {
                    objImageForm = new ImageForm({
                        elForm: '#' + o.formPostQuestion,
                        elFileSelect: '#' + o.postFileSelect,
                        elSelectTrigger: '#' + o.btnPostAttach,
                        elPreviewContainer: '#' + o.postAttachments,
                        maxImages: 6,
                        onTrigger: function () {
                            openQuestionForm();
                        },
                        onChange: function() {
                            $previewQuestion.removeClass('available');
                            var imgCount = this.hasImages(),
                                $elFeatureNSFW = $('#feature-nsfw');
                            if (imgCount >= 1) {
                                $elFormImageCount.removeClass('hidden').children('.count').html(imgCount);
                                $elFeatureNSFW.removeClass('disabled');
                            } else {
                                $elFormImageCount.addClass('hidden');
                                $elFeatureNSFW.addClass('disabled');
                                $elFeatureNSFW.children('[type=checkbox]').removeAttr('checked');
                            }
                        }
                    });
                });

                _bindEvents();
            };

        init(options);
    };
});
